module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fNYeN"))).then(() => parcelRequire('37nVf'));